import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Menu, X, User, LogOut } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { Button } from './Button';
const navLinks = [{
  name: 'Profil BK',
  path: '/profil'
}, {
  name: 'Bimbingan',
  path: '/bimbingan'
}, {
  name: 'Konseling',
  path: '/konseling'
}, {
  name: 'Edukasi',
  path: '/edukasi'
}, {
  name: 'Orang tua',
  path: '/orang-tua'
}, {
  name: 'Asesmen',
  path: '/asesmen'
}, {
  name: 'Jurnal',
  path: '/jurnal'
}, {
  name: 'Pelaporan',
  path: '/pelaporan'
}, {
  name: 'Rate Us',
  path: '/rate-us'
}];
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const {
    isAuthenticated,
    user,
    logout
  } = useAuth();
  useEffect(() => {
    const handleScroll = () => {
      const y = window.scrollY;
      setScrolled(y > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <nav className="fixed top-0 left-0 w-full z-50 transition-all duration-300" style={{
    height: scrolled ? 64 : 80,
    backgroundColor: scrolled ? 'rgba(255, 228, 235, 0.75)' // soft pink glass
    : 'rgba(255, 240, 245, 0.65)',
    // lighter pink
    backdropFilter: 'blur(18px)',
    borderBottom: '1px solid rgba(255, 182, 193, 0.25)'
  }} data-id="element-108">
      <div className="max-w-7xl mx-auto px-4 h-full" data-id="element-109">
        <div className="flex justify-between items-center h-full" data-id="element-110">
          {/* LOGO */}
          <Link to="/" className="flex items-center gap-3 whitespace-nowrap" data-id="element-111">
            <motion.img src="https://yrcfwfrejpzvafteucff.supabase.co/storage/v1/object/public/assets/igi%20-%204.png" className="rounded-lg" animate={{
            width: scrolled ? 30 : 36,
            height: scrolled ? 30 : 36
          }} transition={{
            duration: 0.2
          }} alt="logo" data-id="element-112" />

            <motion.span animate={{
            fontSize: scrolled ? 14 : 16
          }} className="font-semibold tracking-wide text-gray-800" data-id="element-113">
              Digicouns
            </motion.span>
          </Link>

          {/* DESKTOP MENU */}
          <div className="hidden lg:flex items-center gap-6 flex-1 justify-center whitespace-nowrap" data-id="element-114">
            {navLinks.map(link => {
            const isActive = location.pathname === link.path;
            return <Link key={link.path} to={link.path} className={`relative px-2 py-2 text-sm transition ${isActive ? 'text-pink-700 font-medium' : 'text-gray-600 hover:text-pink-700'}`} data-id="element-115">
                  {link.name}

                  {/* ACTIVE UNDERLINE (APPLE STYLE) */}
                  {isActive && <motion.div layoutId="underline" className="absolute left-0 right-0 -bottom-[6px] h-[2px] bg-pink-500 rounded-full" data-id="element-116" />}
                </Link>;
          })}
          </div>

          {/* AUTH */}
          <div className="hidden lg:flex items-center gap-4" data-id="element-117">
            {isAuthenticated ? <>
                <div className="flex items-center gap-2 text-sm text-gray-700" data-id="element-118">
                  <div className="w-8 h-8 rounded-full bg-pink-100 flex items-center justify-center" data-id="element-119">
                    <User size={16} data-id="element-120" />
                  </div>
                  <span className="truncate max-w-[120px]" data-id="element-121">
                    {user?.name || user?.email}
                  </span>
                </div>

                <Button variant="ghost" size="sm" onClick={logout} data-id="element-122">
                  <LogOut size={18} data-id="element-123" />
                </Button>
              </> : <Link to="/login" data-id="element-124">
                <Button size="sm" data-id="element-125">Masuk</Button>
              </Link>}
          </div>

          {/* MOBILE */}
          <button onClick={() => setIsOpen(!isOpen)} className="lg:hidden p-2 rounded-lg hover:bg-pink-100" data-id="element-126">
            {isOpen ? <X size={24} data-id="element-127" /> : <Menu size={24} data-id="element-128" />}
          </button>
        </div>
      </div>

      {/* MOBILE MENU */}
      {isOpen && <div className="lg:hidden bg-pink-50 border-t border-pink-100 px-4 py-4 space-y-2" data-id="element-129">
          {navLinks.map(link => {
        const isActive = location.pathname === link.path;
        return <Link key={link.path} to={link.path} onClick={() => setIsOpen(false)} className={`block px-4 py-3 rounded-xl text-sm ${isActive ? 'bg-pink-100 text-pink-700' : 'text-gray-600 hover:bg-pink-100'}`} data-id="element-130">
                {link.name}
              </Link>;
      })}

          <div className="pt-4 border-t border-pink-100" data-id="element-131">
            {isAuthenticated ? <Button fullWidth variant="outline" onClick={logout} data-id="element-132">
                Logout
              </Button> : <Link to="/login" onClick={() => setIsOpen(false)} data-id="element-133">
                <Button fullWidth data-id="element-134">Masuk</Button>
              </Link>}
          </div>
        </div>}
    </nav>;
}